import React, { useState, useEffect, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import { Modal } from 'react-bootstrap'
import { notify } from 'helpers/helpers';

function Index({ data, poses, modal, toggleModal }) {
	const { t } = useTranslation()
	const reduxAccount = useSelector(state => state.account)

	const [mapState, setMapState] = useState({
		center: [],
		zoom: 13,
		controls: ["zoomControl"]
	});
	const [modalMap, setModalMap] = useState(false)

	function toggleModalMap(bool = false) {
		setModalMap(bool)
		if (!bool) toggleModal(bool, 'map')
	}

	function calculateCenter() {
		// Преобразуем координаты в числа
		const coordinates = data
			.map(item => {
				const lat = parseFloat(item.client_latitude);
				const lon = parseFloat(item.client_longitude);
				if (!isNaN(lat) && !isNaN(lon)) {
					return [lat, lon];
				}
				return null;
			})
			.filter(coord => coord !== null);

		if (coordinates.length === 0 && poses.length === 0) {
			notify(t('no_orders_with_coordinates'))
			return;
		}

		if (coordinates.length === 0) {
			setMapState(prev => ({
				...prev,
				center: [poses[0]['latitude'], poses[0]['longitude']]
			}));
			setModalMap(modal.map)
			return;
		}

		const avgLat = coordinates.reduce((sum, coord) => sum + coord[0], 0) / coordinates.length;
		const avgLon = coordinates.reduce((sum, coord) => sum + coord[1], 0) / coordinates.length;

		setMapState(prev => ({
			...prev,
			center: [avgLat, avgLon]
		}));
		setModalMap(modal.map)
	}

	useEffect(() => {
		if (modal.map) calculateCenter()

	}, [data, modal]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL UPDATE CLIENT */}
			<Modal show={modalMap} animation={false} centered size="xl"
				onHide={() => toggleModalMap()}>
				<Modal.Body>
					<div style={{ 'height': '700px', 'width': '100%' }}>
						<YMaps
							style={{ 'height': '700px', 'width': '100%' }}
							query={{
								load: "package.full",
								apikey: `${reduxAccount.map_token}`
							}}>
							<Map
								state={mapState}
								defaultOptions={{
									copyrightUaVisible: false,
									yandexMapDisablePoiInteractivity: true,
								}}
								style={{ 'height': '700px', 'width': '100%' }}>
								{poses?.map((item, index) => (
									<Fragment key={index}>
										{item.latitude &&
											<Placemark key={index}
												geometry={[item.latitude, item.longitude]}
												options={{ preset: 'islands#redStretchyIcon' }}
												properties={{
													// Используем balloonContent для отображения текста
													// В режиме по умолчанию balloonContent показывается по клику
													// Но мы можем сделать его открытым постоянно, если это нужно
													iconContent: item.name,
													intContent: t('pos'),
													balloonContent: `
													<div className="d-flex flex-column gap-3">
														<div>
															<div class="d-flex gap-2">
																<i class="uil uil-restaurant"></i>
																<span>${item.name}</span>
															</div>
															<div class="d-flex gap-2">
																<i class="uil uil-phone"></i>
																<span>${item.phone}</span>
															</div>
														</div>
														<div>${t('orders')}: <b>${item.count}</b></div>
													</div>
												`
												}}
											/>
										}
									</Fragment>
								))}
								{data?.map((item, index) => (
									<Fragment key={index}>
										{item.client_latitude &&
											<Placemark key={index} geometry={[item.client_latitude, item.client_longitude]}
												properties={{
													// Используем balloonContent для отображения текста
													// В режиме по умолчанию balloonContent показывается по клику
													// Но мы можем сделать его открытым постоянно, если это нужно
													intContent: t('client'),
													balloonContent: `
													<div className="d-flex flex-column gap-3">
														<div>
															<div class="d-flex gap-2">
																<i class="uil uil-user"></i>
																<span>${item.client_name}</span>
															</div>
															<div class="d-flex gap-2">
																<i class="uil uil-phone"></i>
																<span>${item.client_phone}</span>
															</div>
														</div>
														<div><b>ID: ${item.id}</b></div>
													</div>
													`
												}}
											/>
										}
									</Fragment>
								))}
							</Map>
						</YMaps>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL UPDATE CLIENT */}
		</>
	)
}

export default Index